import * as Html from "../../util/Html.ts";
export {init}
Html.registerWidget('widget/form/radio',{init:init})

function init(elem){
    
  let 
    input = elem.find('input'),
    selectable = elem.find('[data-value]');
  
  function updateUI(){
    var value = input.val();
    selectable.each((idx,obj)=>{
      $(obj).toggleClass('selected',$(obj).attr('data-value')===value)
    })
  }
  input.on('change',updateUI)
  updateUI();
  selectable.on('click',function(){
    input.val($(this).attr('data-value')).trigger('change')
  })
}
